import { useEffect } from 'react';
import { createPortal } from 'react-dom';

import './Drawer.scss';

export const Drawer = ({ children }) => {
  // Drawer is appended through a portal to the "#drawer" div in the html template.
  const isSSR = typeof document.getElementById !== 'function';
  const drawerRoot = isSSR ? undefined : document.getElementById('drawer');
  const el = isSSR ? undefined : document.createElement('div');

  useEffect(() => {
    if (isSSR) {
      return;
    }
    document.body.classList.add('drawer-body--open');
    drawerRoot.appendChild(el);

    return function cleanup(): void {
      document.body.classList.remove('drawer-body--open');
      drawerRoot.removeChild(el);
    };
  });

  if (isSSR) {
    // tslint:disable-next-line:no-null-keyword
    return null;
  }

  return createPortal(
    children,
    el
  );
};

export default Drawer;
